import { render } from "./CharacterAnime.vue?vue&type=template&id=825eefe4"
import script from "./CharacterAnime.vue?vue&type=script&lang=js"
export * from "./CharacterAnime.vue?vue&type=script&lang=js"

import exportComponent from "/Users/n0m4dz/workspace/projects/seeroo-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__